<router-outlet (activate)="previousUrlService.navigated.next(true)"></router-outlet>
